import { render, staticRenderFns } from "./Drf.vue?vue&type=template&id=368dbd8f&scoped=true"
import script from "./Drf.vue?vue&type=script&lang=js"
export * from "./Drf.vue?vue&type=script&lang=js"
import style0 from "./Drf.vue?vue&type=style&index=0&id=368dbd8f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "368dbd8f",
  null
  
)

export default component.exports